// Stylised moustache + double-line mark inspired by the Monsieur Toast logo
export const MustacheMark = ({ className = "h-6 w-auto", color = "currentColor" }) => (
  <svg
    viewBox="0 0 240 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* left line */}
    <rect x="6" y="38" width="76" height="3" fill={color} />
    {/* right line */}
    <rect x="158" y="38" width="76" height="3" fill={color} />
    {/* moustache */}
    <path
      d="M120 16c-9 0-15 6-19 14-3 6-7 10-13 10-5 0-9-2-11-7 0 9 7 16 17 16 8 0 14-4 17-10 1-2 3-4 4-5 0-1 1-1 2-1l3 0c1 0 2 0 2 1 1 1 3 3 4 5 3 6 9 10 17 10 10 0 17-7 17-16-2 5-6 7-11 7-6 0-10-4-13-10-4-8-10-14-19-14z"
      fill={color}
    />
  </svg>
);

export default MustacheMark;
